import React, {useContext, useEffect, useState} from 'react'

import Field from "../core/ui/forms/field";
import SessionContext from 'SessionContext'
import {useHistory} from "react-router-dom";
import UnsavedChanges from "partials/unsaved-changes";
import ConfirmSuccess from "../core/ui/confirm-success";


export default function DataPermissionForm(props) {
  const session = useContext(SessionContext)
  const history = useHistory();
  const [modified, setModified] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [disableSave, setDisableSave] = useState(true);
  const [dataPermissionEditing, setDataPermissionEditing] = useState({});
  const [DataPermission, setDataPermission] = useState();
  const [showSuccess, setShowSuccess] = useState(false);
  const [allowNavigateAway, setAllowNavigateAway] = useState(false);

  const [errors, setErrors] = useState({
    id: '',
    description: '',
  })

  function loadDataPermission(data_permission_id) {
    setLoaded(false);
    session.query('reference/permissions/loadData', {id: data_permission_id})
        .then((response) => {
          setDataPermission(response)
          setLoaded(true);
        })
  }

  useEffect(() => {
    if (props.args.data_permission_id) {
      loadDataPermission(props.args.data_permission_id);
    } else {
      setDataPermission({
        id: "",
        name: "",
      })
      setLoaded(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const storeOldValues = () => {
      if(DataPermission.id !== dataPermissionEditing.id) {
        setDataPermissionEditing(DataPermission);
      }
    }

    const checkForEmpty = () => {
      if(DataPermission.name && DataPermission.name === "") {
        setDisableSave(true);
      } else {
        setDisableSave(false);
        setModified(true);
      }
    }

    const checkForChanges = () => {
      const hasChanged = JSON.stringify(DataPermission) !== JSON.stringify(dataPermissionEditing);
      if(hasChanged) {
        setDisableSave(false); 
        setModified(true);
      } else {
        setDisableSave(true);
        setModified(false);
      }
    }

    if(DataPermission && Object.keys(DataPermission).length !== 0) {
      storeOldValues();
      checkForEmpty();
      checkForChanges();
      if(DataPermission.id === "") {
        checkForChanges();
      }
    } 
    
  }, [DataPermission, dataPermissionEditing])

  function onClickSave(ev) {
    ev.stopPropagation();
    ev.preventDefault();

    const newErrors = {}
    if (!DataPermission.name) newErrors.code = 'Required'
    setErrors(newErrors)
    if (Object.keys(newErrors).length > 0) {
      return;
    }
    setAllowNavigateAway(true);
    setModified(false);

    const newDataPermission = {
      ...DataPermission
    }

    if (!!newDataPermission.id) {
      session.command('admin/update_data_permission', newDataPermission, {}, { defaultErrorHandling: false })
        .then((response) => {
          setDataPermission(response);
          setShowSuccess(true);
        })
        .then(() => {
          setTimeout(() => {
            setShowSuccess(false);
            history.push('admin-data-permissions');
          }, 2000);
        })
        .catch((error) => {
          console.log("DataPermission Update Failed", JSON.stringify(error))
        })
    }
    else {
      session.command('admin/create_data_permission', newDataPermission, {}, { defaultErrorHandling: false })
        .then((response) => {
          setDataPermission(response);
          setShowSuccess(true);
        })
        .then(() => {
          setTimeout(() => {
            setShowSuccess(false);
            history.push('admin-data-permissions');
          }, 2000);
        })
        .catch((error) => {
          console.log("DataPermission Create Failed", JSON.stringify(error))
        })
    }
  }

  function setName(ev) {
    setDataPermission({...DataPermission, name: ev.target.value.toLowerCase()})
    if (ev.target.value) {
      setErrors((prev) => delete prev.name)
      setModified(true);
    }
  }

  function goBack() {
    history.push('/admin-data-permissions')
  }

  return (  loaded &&
    <form className='page admin-page data-permission-form-page' onSubmit={e => e.preventDefault()}>
      <div className="list-header sticky-page-header">
        <button className='new-button' onClick={goBack}>
          <i className="bi bi-chevron-left" /> Back
        </button>
        <h1>Data Permission</h1>
        <i className="spacer"/>
        <div className='data-permission-form-buttons'>
          <button className='new-button promote' onClick={onClickSave} disabled={disableSave}>
            Save Changes
          </button>
        </div>
      </div>
      <section className='data-permission-form-details'>
        <Field label='* Name' className='data-permission-form-details-heading' error={errors.name}>
          <input type='text'
                 value={DataPermission.name}
                 className='data-permission-form-details-description'
                 onChange={setName} />
        </Field>
      </section>
      <div>
        <UnsavedChanges hasUnsavedChanges={allowNavigateAway ? false : modified} />
        <ConfirmSuccess show={showSuccess} 
        label={DataPermission.id === "" ? "Data Permission Created Successfully" : "Data Permission Updated Successfully"} />
      </div>
    </form>
  )
}
